import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const COLORS = ['#10b981', '#cbd5e1']; // Green for answered, Gray for unanswered

const AssessmentCompletionChart = ({ data }) => {
  const chartData = [
    { name: 'Answered', value: data.answeredQuestions || 0 },
    { name: 'Unanswered', value: (data.totalQuestions || 0) - (data.answeredQuestions || 0) },
  ].filter(item => item.value > 0);

  const hasData = chartData.length > 0 && (data.totalQuestions || 0) > 0;

  const renderCustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      const percentage = data.payload.percentage || 0;
      return (
        <div style={{
          backgroundColor: '#fff',
          border: '1px solid #ddd',
          borderRadius: '4px',
          padding: '10px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        }}>
          <p style={{ margin: 0, fontWeight: 'bold', color: '#000' }}>
            {`${data.name}: ${data.value} questions (${percentage.toFixed(1)}%)`}
          </p>
        </div>
      );
    }
    return null;
  };

  if (!hasData) {
    return (
      <div style={{
        height: 300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        color: '#888'
      }}>
        No completion data available
      </div>
    );
  }

  // Calculate percentages
  const total = data.totalQuestions || 1;
  const chartDataWithPercentage = chartData.map(item => ({
    ...item,
    percentage: (item.value / total) * 100
  }));

  return (
    <ResponsiveContainer height={300} width="100%">
      <PieChart>
        <Pie
          data={chartDataWithPercentage}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ name, percentage }) => `${name}: ${percentage.toFixed(1)}%`}
          outerRadius={100}
          innerRadius={40}
          dataKey="value"
          animationDuration={800}
          animationEasing="ease-out"
        >
          {chartDataWithPercentage.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip content={renderCustomTooltip} />
        <Legend
          layout="horizontal"
          align="center"
          verticalAlign="bottom"
          iconType="circle"
          wrapperStyle={{ paddingTop: '20px' }}
          formatter={(value, entry) => {
            const dataItem = chartDataWithPercentage.find(item => item.name === value);
            return `${value}: ${dataItem ? dataItem.value : 0} questions`;
          }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

AssessmentCompletionChart.propTypes = {
  data: PropTypes.shape({
    answeredQuestions: PropTypes.number,
    totalQuestions: PropTypes.number,
  }).isRequired,
};

export default AssessmentCompletionChart;

